/*
 * Taking a state badge (reading / watching / idle / away) off a bubble, and TELLING THE SESSIONS LIST.
 *
 * The bubble's badge is a DOM element, but the Sessions drawer's row glyphs are React state, rebuilt only when one of these events fires. A removal that does not emit leaves the row
 * wearing a glyph the bubble no longer has: on production the last session of a day kept its READING glyph for hours after it left (2026-10-15), because the departure cleanup
 * removed the badge and said nothing. Every place that removes one of these badges goes through here, so the removal and the notification cannot be separated again.
 *
 * It emits only when something WAS removed, so the common case (no such badge) costs one selector query and no event.
 */
export type BadgeKind = "reading" | "watching" | "idle" | "away";

export const BADGE_EVENTS: Record<BadgeKind, { event: string; flag: string }> = {
  reading: { event: "sessionReadingChanged", flag: "reading" },
  watching: { event: "sessionWatchingChanged", flag: "watching" },
  idle: { event: "sessionIdleChanged", flag: "idle" },
  away: { event: "sessionAwayChanged", flag: "away" },
};

interface BadgeSelection {
  selectAll(selector: string): { empty(): boolean; remove(): unknown };
}
type Emit = (event: string, payload: Record<string, unknown>) => unknown;

export const dropBadge = (parent: BadgeSelection, kind: BadgeKind, sessionId: string, emit: Emit): boolean => {
  const found = parent.selectAll(`[data-pulse-${kind}="true"][visitor_id="${sessionId}"]`);
  const had = !found.empty();
  found.remove();
  if (had) {
    const { event, flag } = BADGE_EVENTS[kind];
    emit(event, { sessionId, [flag]: false });
  }

  return had;
};

export const dropAllBadges = (parent: BadgeSelection, sessionId: string, emit: Emit, kinds: BadgeKind[]): BadgeKind[] =>
  kinds.filter((kind) => dropBadge(parent, kind, sessionId, emit));
